import type { FC } from 'react'
import type { GetUsers_getUsers } from '@g4g/graphql/src/shop/__generated__/GetUsers'
import { classNames } from '@g4g/utils/src/react/class-names'
import RecipientAvatar from './RecipientAvatar'
import SocialAccountLogo from '@g4g/ui/src/components/SocialAccountLogo'
import { vipExpLevel } from '@g4g/utils/src/gameDataUtils'

const RecipientSecondaryInfo: FC<{
  checked?: boolean
  recipient: GetUsers_getUsers
}> = ({ checked, recipient }) => (
  <div
    className={classNames(
      'flex items-center space-x-1 text-xs',
      checked ? 'text-white' : 'text-white/50'
    )}
  >
    <div>
      <span className="font-bold">ID</span>
      <span className="after:content-['\00b7'] after:ml-1">{' ' + recipient.cosId}</span>
    </div>
    <div>
      <span className="font-bold">VIP</span>
      <span>{' ' + vipExpLevel(recipient.userState.vipXP)}</span>
    </div>
  </div>
)

const RecipientInfo: FC<{
  checked?: boolean
  recipient: GetUsers_getUsers
}> = ({ recipient, checked }) => (
  <div className="flex flex-col truncate">
    <div className="flex items-center space-x-1">
      <h3 className={classNames('font-bold truncate', checked ? 'text-white' : 'text-white/80')}>
        {recipient.primaryLogin?.displayName}
      </h3>
      {recipient.primaryLogin?.platform && (
        <div className="flex items-center justify-center w-4 h-4">
          <SocialAccountLogo provider={recipient.primaryLogin.platform} />
        </div>
      )}
    </div>
    <RecipientSecondaryInfo checked={checked} recipient={recipient} />
  </div>
)

const RecipientCard: FC<{
  recipient: GetUsers_getUsers
  checked: boolean
}> = ({ recipient, checked }) => (
  <div
    className={classNames(
      'relative w-full rounded-lg shadow-md',
      'flex py-4 px-4 text-white cursor-pointer focus:outline-none',
      checked
        ? 'ring-2 ring-brown-400 bg-brown-700/40'
        : 'ring-1 ring-brown-700/50 lg:hover:bg-brown-700/10'
    )}
  >
    <div className="flex items-center w-full">
      <div className="flex justify-between w-full">
        <div className="flex space-x-2 truncate">
          <RecipientAvatar recipient={recipient} />
          <RecipientInfo recipient={recipient} checked={checked} />
        </div>
      </div>
    </div>
  </div>
)

export default RecipientCard
